var $725af9f963c35984$exports = {};
$725af9f963c35984$exports = {
    "endTime": `Ora de sf\xe2r\u{219}it`,
    "startTime": `Ora de \xeenceput`,
    "time": `Ora`
};


export {$725af9f963c35984$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
